export default __webpack_public_path__ + "static/media/logo-white.07bb3a71.svg";